/** @jsx h */
import FilterFieldsetAccordion from './FilterFieldsetAccordion';
import Sorting from './Sorting';
import FilterRemoveAll from './FilterRemoveAll';
import FilterActive from './FilterActive';

const FilterContainer = ({
  facets,
  facetsActive,
  sorting,
  triggerAjaxSubmit,
  pluginNamespace,
  restrictionFilters,
  resetFilters,
}) => {
  return (
    <div>
      {facets.map(
        (facet, index) =>
          facet.options.length > 0 && (
            <FilterFieldsetAccordion
              id={index}
              key={facet.label}
              title={facet.label}
              facet={facet}
              optionsActiveCount={
                facetsActive.selected.filter(
                  option => option.name === facet.name
                ).length
              }
              accordionConfig={index === 0 ? "{'initOpened': true}" : '{}'}
              triggerAjaxSubmit={triggerAjaxSubmit}
              pluginNamespace={pluginNamespace}
            />
          )
      )}
      {sorting.length > 0 && (
        <Sorting
          sorting={sorting}
          triggerAjaxSubmit={triggerAjaxSubmit}
          pluginNamespace={pluginNamespace}
        />
      )}
      {facetsActive && (
        <div className="form form--search">
          <FilterActive
            facetsActive={facetsActive}
            triggerAjaxSubmit={triggerAjaxSubmit}
          />
          <FilterRemoveAll
            pluginNamespace={pluginNamespace}
            resetFilters={resetFilters}
          />
        </div>
      )}
    </div>
  );
};

export default FilterContainer;
